import React, { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import UserContext from "./UserContext";

// Decode JWT exp claim without verifying signature (client-side expiry check only).
function isTokenExpired(token) {
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    return payload.exp && Date.now() / 1000 > payload.exp;
  } catch {
    return true;
  }
}

// requiredRole: "patient" | "clinician" | undefined (any authenticated user)
function ProtectedRoute({ children, requiredRole }) {
  const { user, setUser } = useContext(UserContext);
  const location = useLocation();

  if (!user || !user.token) {
    return <Navigate to="/" replace />;
  }

  if (isTokenExpired(user.token)) {
    setUser(null);
    return <Navigate to="/" replace />;
  }

  // Enforce first-login password change for every protected page except /change-password itself
  if (user.force_password_change && location.pathname !== "/change-password") {
    return <Navigate to="/change-password?forced=true" replace />;
  }

  // Role gate: patients cannot access clinician routes and vice versa
  if (requiredRole && user.role !== requiredRole) {
    return <Navigate to="/home" replace />;
  }

  return children;
}

export default ProtectedRoute;
